import RepresentativeSimpleView from './RepresentativeSimpleView'

export default RepresentativeSimpleView
